import { useCallback } from 'react';

import classNames from 'classnames';

import { Icon } from '@iconik-io/uad';

import type { SelectOption, ValueComponentProps } from './types';

import mixins from '../../styles/core/mixins.module.css';
import styles from './value.module.css';

const Value = <IO extends SelectOption>({
  value,
  onDelete,
}: ValueComponentProps<IO>) => {
  const handleDeleteClick = useCallback(
    () => onDelete?.(value),
    [onDelete, value],
  );

  return (
    <div className={styles.root} role="listitem">
      <button
        type="button"
        className={classNames(styles.delete, mixins.reset_button)}
        onClick={handleDeleteClick}
        aria-label={`Remove ${value.label}`}
      >
        <Icon name="deletion_erase" />
      </button>
      <div className={styles.label}>{value.label}</div>
    </div>
  );
};

export default Value;
